<!--
 * @Description: 各篇浏览内容排行，多个地方公用修改时需要注意
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div v-if="showTitle" class="bi-tmpl-detail__right__cmpt__title">
      {{ curItem.title }}
    </div>
    <div>
      <span
        v-if="showSecordTitle"
        style="margin-top: 0"
        class="bi-tmpl-detail__right__cmpt__title"
      >
        请选择表格样式
      </span>
      <span
        v-if="curItem.tips"
        style="margin-top: 0"
        class="bi-tmpl-detail__right__cmpt__tips"
      >
        {{ curItem.tips }}
      </span>
    </div>

    <Carousel ref="carouselRef" :itemHeight="1000" :itemWidth="420 + 56">
      <div
        style="width: 100%"
        v-for="(item, index) in group(TYPE_MAPPING, 1)"
        :key="index"
      >
        <div v-for="child in item" :key="child.value">
          <BaseCard
            :style="{
              width: child.value === 'pc-module-ranking-5' ? '406px' : '421px',
              height: '445px',
              textAlign: 'center'
            }"
            @click="onChange(child.value)"
          >
            <component :is="cmpName(child.com)" />
          </BaseCard>
          <div
            style="
              text-align: center;
              box-sizing: border-box;
              padding-top: 16px;
              margin-bottom: 16px;
            "
          >
            <BaseRadio
              :value="child.value"
              :model-value="curItem.value"
            ></BaseRadio>
          </div>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio, BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleRanking from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-ranking/index';

const props = withDefaults(
  defineProps<{
    showTitle?: boolean;
    showSecordTitle?: boolean;
    childKey?: string;
  }>(),
  {
    showTitle: true,
    showSecordTitle: true
  }
);

const TYPE_MAPPING = [
  {
    value: '12',
    com: 'pc-module-ranking-1',
    index: 1
  },
  {
    value: '7',
    com: 'pc-module-ranking-2',
    index: 2
  },
  {
    value: '13',
    com: 'pc-module-ranking-3',
    index: 3
  },
  {
    value: '14',
    com: 'pc-module-ranking-4',
    index: 4
  },
  {
    value: '101',
    com: 'pc-module-ranking-5',
    index: 5
  }
];

const cmpName = name => {
  return PcModuleRanking.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt({
  childKey: props.childKey
});
</script>
<style lang="scss"></style>
